import Matrix from 'ml-matrix';
import { reimAutoPhaseCorrection, reimFFT, reimPhaseCorrection, } from 'ml-spectra-processing';
import { apodization, } from '../../../apodization/apodization';
import { digitalFilter } from './digitalFilter';
import { removeDCOffset } from './removeDCOffset';
import { zeroFilling } from './zeroFilling';
export function fftDirectDimension(data, options) {
    const { re: reData, im: imData } = data;
    const nbRows = reData.length;
    const nbColumns = reData[0].length;
    const { zeroFilling: zeroFillingF2, digitalFilterValue = 0 } = options;
    const { factor: f2Factor = 2 } = zeroFillingF2 || {};
    const nbPointsF2 = zeroFillingF2?.nbPoints || 2 ** Math.round(Math.log2(nbColumns * f2Factor));
    const reFFT = new Matrix(nbRows, nbPointsF2);
    const imFFT = new Matrix(nbRows, nbPointsF2);
    const { apodization: apodizationF2 } = options;
    let { ph0: ph0F2, ph1: ph1F2, mode: pcModeF2 = 'no', } = options?.phaseCorrection || {};
    for (let i = 0; i < nbRows; i++) {
        const newData = digitalFilter({ re: reData[i], im: imData[i] }, { digitalFilterValue });
        Object.assign(newData, removeDCOffset(newData, { digitalFilterValue }));
        if (apodizationF2) {
            const { re: aRe, im: aIm } = apodization(newData, apodizationF2);
            Object.assign(newData, { re: aRe, im: aIm });
        }
        Object.assign(newData, zeroFilling(newData, { digitalFilterValue, nbPoints: nbPointsF2 }));
        Object.assign(newData, reimFFT(newData, { applyZeroShift: true }));
        const dfResidual = (digitalFilterValue - Math.round(digitalFilterValue)) * Math.PI * 2;
        if (dfResidual > 0) {
            Object.assign(newData, reimPhaseCorrection(newData, 0, -dfResidual));
        }
        if (i === 0 &&
            pcModeF2 === 'pk' &&
            ph0F2 === undefined &&
            ph1F2 === undefined) {
            const phased = reimAutoPhaseCorrection(newData, { magnitudeMode: false });
            ph0F2 = phased.ph0;
            ph1F2 = phased.ph1;
        }
        if (pcModeF2 === 'pk' && ph0F2 !== undefined && ph1F2 !== undefined) {
            Object.assign(newData, reimPhaseCorrection(newData, (ph0F2 * Math.PI) / 180, (ph1F2 * Math.PI) / 180));
        }
        reFFT.setRow(i, newData.re);
        imFFT.setRow(i, newData.im);
    }
    return {
        re: reFFT,
        im: imFFT,
    };
}
//# sourceMappingURL=fftDirectDimension.js.map